import { Injectable, inject, PLATFORM_ID, DestroyRef } from '@angular/core';
import { WINDOW } from './window/window.service';
import { take, map, filter } from 'rxjs/operators';
import { EMPTY, fromEvent, of } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class QuickviewAvailabilityService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly window = inject(WINDOW);
  private readonly destroyRef = inject(DestroyRef);

  isAvailable$() {
    if (isPlatformServer(this.platformId)) {
      return EMPTY;
    }

    const quickview = this.window.quickview;

    if (quickview?.openProductQuickView) {
      return of(quickview);
    }

    return fromEvent(this.window, 'QuickviewAvailable').pipe(
      map(() => this.window.quickview),
      filter(
        (quickview): quickview is Header.QuickView => quickview?.openProductQuickView !== undefined,
      ),
      take(1),
      takeUntilDestroyed(this.destroyRef),
    );
  }

  queueUntilAvailable(callback: (qv: Header.QuickView) => void) {
    this.isAvailable$().subscribe((quickview) => {
      callback(quickview);
    });
  }
}
